import React, { useState } from 'react';

export default function AuthorList() {
  const [showAll, setShowAll] = useState(false);


  const mainAuthors = [
    { name: "Michael Galarnyk*", url: "https://scholar.google.co.in/citations?user=G567BHUAAAAJ&hl=en", affiliation: 1 },
    { name: "Siddharth Lohani*", url: "#", affiliation: 1 },
    { name: "Vidhyakshaya Kannan†", url: "#", affiliation: 2 },
    { name: "Sagnik Nandi†", url: "#", affiliation: 1 },
    { name: "Aman Patel†", url: "#", affiliation: 1 },
    { name: "Liqin Ye", url: "#", affiliation: 1 },
    { name: "Arnav Hiray", url: "#", affiliation: 1 },
    { name: "Rutwik Routu", url: "https://scholar.google.com/citations?user=w38pbXQAAAAJ&hl=en", affiliation: 3 },
    { name: "Prasun Banerjee", url: "#", affiliation: 1 },
    { name: "Siddhartha Somani", url: "#", affiliation: 1 },

    { name: "Sudheer Chava", url: "https://scholar.google.com/citations?user=AXYf-i8AAAAJ&hl=en", affiliation: 1 },
  ];


  const handleToggle = () => setShowAll(!showAll);

  // If you want to keep the ellipsis/collapse logic, you can adjust how many authors to show by default
  const defaultVisibleCount = 2;
  const displayed = showAll
    ? mainAuthors
    : [
        ...mainAuthors.slice(0, defaultVisibleCount),
        'ELLIPSIS',
        ...mainAuthors.slice(-1)
      ];

  return (
    <div className="author-list">
      {displayed.map((item, idx) => {
      if (item === 'ELLIPSIS') {
        return (
          <span
            key="ellipsis"
            className="author-ellipsis"
            onClick={handleToggle}
          >
            …
          </span>
        );
      }
      const isLast = idx === displayed.length - 1;
      return (
        <React.Fragment key={idx}>
          <a
            className="author-link"
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.name}
            <span style={{color: 'black'}}>
              {!isLast && ","}
            </span>
            <sup style={{ 
              verticalAlign: 'baseline', 
              position: 'relative', 
              top: '-0.5em', 
              fontSize: '0.75em',
              marginLeft: '-0.2em'
            }}>
              {item.affiliation}
            </sup>
          </a>
          {!isLast && <span>&nbsp;</span>}
        </React.Fragment>
      );
  })}

      {showAll && (
      <span
        className="author-ellipsis"
        onClick={handleToggle}
      >
        (Collapse)
      </span>
    )}

      <div style={{ marginTop: '1rem', fontSize: '0.95rem' }}>
      <span>* Corresponding and Equal First Authors: {'{mgalarnyk3, slohani7}@gatech.edu'}</span><br/>
      <span>† Core Contributors</span>
    </div>
    </div>
  );
}
